"use client";

import { useAuth } from '@/contexts/AuthContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Home from "@/pages/Home"; // FIXED: Changed to default import (no curly braces)
import { MadeWithDyad } from "@/components/made-with-dyad";

const Index = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        navigate('/dashboard');
      } else {
        // For unauthenticated users, do not redirect to /login; stay on home (public page)
        // The Home component will handle public content
      }
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  // Render Home for public access (no redirect to login)
  return (
    <>
      <Home />
    </>
  );
};

export default Index;